import { render, staticRenderFns } from "./EditTier.vue?vue&type=template&id=7f200e42&"
import script from "./EditTier.vue?vue&type=script&lang=js&"
export * from "./EditTier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports